import { Slot } from '@radix-ui/react-slot';
import type React from 'react';
import { cn } from '../../styles/lib/utils';

type TableHeadGroupProps = React.ComponentProps<'th'> & {
  asChild?: boolean;
};

function TableHeadGroup({ className, asChild = false, children, ...props }: TableHeadGroupProps) {
  const Comp = asChild ? Slot : 'th';
  return (
    <Comp
      role="columnheader"
      className={cn(
        'bg-grey-20 flex items-center justify-center overflow-hidden p-0 h-[18px] leading-[18px] rounded-lg shrink-0 text-2xs font-bold uppercase text-grey-80 font-noto',
        className,
      )}
      {...props}
    >
      {asChild ? children : <span className="truncate px-1">{children}</span>}
    </Comp>
  );
}

export { TableHeadGroup, type TableHeadGroupProps };
